import { render, staticRenderFns } from "./ItemListEntityMetadata.vue?vue&type=template&id=38034593"
import script from "./ItemListEntityMetadata.vue?vue&type=script&lang=ts"
export * from "./ItemListEntityMetadata.vue?vue&type=script&lang=ts"
import style0 from "./ItemListEntityMetadata.vue?vue&type=style&index=0&id=38034593&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38034593')) {
      api.createRecord('38034593', component.options)
    } else {
      api.reload('38034593', component.options)
    }
    module.hot.accept("./ItemListEntityMetadata.vue?vue&type=template&id=38034593", function () {
      api.rerender('38034593', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemListEntityMetadata.vue"
export default component.exports